import React from 'react';
import Spin from 'react-reveal/Spin';


const Contact = () => {
  const currentYear = new Date().getFullYear();

  const iconStyle = {
    color: 'white', // Set the icon color to black
    margin: '0 10px', // Add spacing between icons
  };

  return (
    
    <footer className="colored-section" id="footer">
      <div className="container-fluid" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spin>
        <a href="mailto:dryousufphysio@gmail.com" target="_blank">
          <i className="social_icon fas fa-envelope fa-2x" style={iconStyle}></i>
        </a>
        </Spin>
        <Spin>
        <a href="https://www.instagram.com/rebounce_physio/" target="_blank"> {/* Replace 'your_instagram_account' with your Instagram account URL */}
          <i className="social_icon fab fa-instagram fa-2x" style={iconStyle}></i>
        </a>
        </Spin>
        <Spin>
        <a href="https://www.facebook.com/profile.php?id=61552702990629" target="_blank">
          <i className="social_icon fab fa-facebook fa-2x" style={iconStyle}></i>
        </a>
        </Spin>
        <Spin>
        <a href="https://wa.me/916300824320" target="_blank">
          <i className="social_icon fab fa-whatsapp fa-2x" style={iconStyle}></i>
        </a>
        </Spin>
      </div>
      <center><p>© {currentYear} Rebounce Physiotherapy</p></center>
    </footer>
    
  );
};

export default Contact;

